const QRBAR_BASE_URL = 'http://qrbar.local';
const HEALTH_TIMEOUT = 2000;
const QR_TIMEOUT = 3000;
const CLEAR_TIMEOUT = 2000;

export class QRbarService {
  /**
   * Check if a QRbar device is online and reachable.
   * GET /health
   * @returns {Promise<{connected: boolean, data?: object}>}
   */
  static async checkHealth() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), HEALTH_TIMEOUT);

      const response = await fetch(`${QRBAR_BASE_URL}/health`, {
        signal: controller.signal,
      });
      clearTimeout(timeoutId);

      if (!response.ok) {
        return { connected: false };
      }

      const data = await response.json();
      return { connected: data.status === 'ok', data };
    } catch {
      return { connected: false };
    }
  }

  /**
   * Send QR code data to the QRbar device for display.
   * POST /qr
   * @param {string} qrData - The URL/text to encode (max 134 chars)
   * @returns {Promise<boolean>} true if successfully displayed
   */
  static async displayQR(qrData) {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), QR_TIMEOUT);

      const response = await fetch(`${QRBAR_BASE_URL}/qr`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: qrData }),
        signal: controller.signal,
      });
      clearTimeout(timeoutId);

      if (!response.ok) return false;

      const result = await response.json();
      return result.status === 'ok';
    } catch {
      return false;
    }
  }

  /**
   * Clear the QRbar display back to splash screen.
   * POST /clear
   * @returns {Promise<boolean>}
   */
  static async clearDisplay() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), CLEAR_TIMEOUT);

      const response = await fetch(`${QRBAR_BASE_URL}/clear`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
      });
      clearTimeout(timeoutId);

      if (!response.ok) return false;

      const result = await response.json();
      return result.status === 'ok';
    } catch {
      return false;
    }
  }
}
